import useRequest from '@/websdk/utils/request';
export default (function () {
    const { exec, isRequestSuccessed } = useRequest({
    name: 'POST_SITE_INSPECTION_SAMPLE',
    url: `/api/inspection/site/samples/`,
    method: 'POST',
  });
 

  return [exec, isRequestSuccessed];
});
